import { render } from "./UserInvite.vue?vue&type=template&id=79d3d7ac"
import script from "./UserInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInvite.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/coaching_user/components/UserInvite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79d3d7ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79d3d7ac', __exports__)) {
    api.reload('79d3d7ac', __exports__)
  }
  
  module.hot.accept("./UserInvite.vue?vue&type=template&id=79d3d7ac", () => {
    api.rerender('79d3d7ac', render)
  })

}


export default __exports__